/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

/**
 * todo
 */
@Component({
	selector: "aigia-judgment",
	templateUrl: "./judgment.component.html",
	styleUrls: ["../floating/floating.component.css", "./judgment.component.css"],
})

export class JudgmentComponent extends FloatingComponent implements OnChanges {

	@Input() public locked: boolean;
	@Input() public shot: any;
	@Input() public fontsize: string;
	@Input() public style: any;

	public judgment = false;

	public hasData: boolean = false;
	public title: string = "Judgment";

	@Output() public progrssChange = new EventEmitter<boolean>();

	public dataSource: { table: any[][], description: { club: number } } = {table: [], description: {club: 0}};

	/**
	 * @returns none
	 */
	private isError(club: number, line: any): boolean {

		const AD = line[1];
		const HB = line[2];
		const TP = line[3];
		const HD = line[4];
		const IM = line[5];
		const HF = line[6];

		let error: boolean = false;

		switch (club) {
			case 1:
				switch (line[0]) {
					case "前傾ライン": {
						const UNDER = AD - 7;
						const OVER = AD + 7;
						error = (((HB < UNDER) || (OVER < HB)) ||
							((TP < UNDER) || (OVER < TP)) ||
							((HD < UNDER) || (OVER < HD)) ||
							((IM < UNDER) || (OVER < IM)) ||
							((HF < UNDER) || (OVER < HF)));
					}
						break;
					case "ネックポジション":
						error = (((HB < -7) || (0 < HB)) ||
							((TP < -9) || (-2 < TP)) ||
							((HD < -2) || (5 < HD)) ||
							((IM < -2) || (5 < IM)) ||
							((HF < -1) || (6 < HF)));
						break;
					case "センターライン":
						error = (((HB < -11) || (1 < HB)) ||
							((TP < -11) || (1 < TP)) ||
							((HD < -14) || (-2 < HD)) ||
							((IM < -18) || (-6 < IM)) ||
							((HF < -14) || (-2 < HF)));
						break;
					case "センターポジション":
						error = (((HB < -6) || (0 < HB)) ||
							((TP < -9) || (-3 < TP)) ||
							((HD < -2) || (4 < HD)) ||
							((IM < 1) || (7 < IM)) ||
							((HF < 1) || (12 < HF)));
						break;
					case "ライトライン": {
						const UNDER = AD - 5;
						const OVER = AD + 1;
						error = (((HB < UNDER) || (OVER < HB)) ||
							((TP < UNDER) || (OVER < TP)))
					}
						break;
					case "レフトライン": {
						const UNDER = AD - 7;
						const OVER = AD - 1;
						error = (((HD < UNDER) || (OVER < HD)) ||
							((IM < UNDER) || (OVER < IM)) ||
							((HF < UNDER) || (OVER < HF)))
					}
						break;
					case "右膝の角度": {

					}
						break;
					case "左膝の角度": {

					}
						break;
					default:
						break;
				}
				break;
			case 7:
				switch (line[0]) {
					case "前傾ライン": {
						const UNDER = AD - 5;
						const OVER = AD + 5;
						error = (((HB < UNDER) || (OVER < HB)) ||
							((TP < UNDER) || (OVER < TP)) ||
							((HD < UNDER) || (OVER < HD)) ||
							((IM < UNDER) || (OVER < IM)) ||
							((HF < UNDER) || (OVER < HF)));
					}
						break;
					case "ネックポジション":
						error = (((HB < -5) || (1 < HB)) ||
							((TP < -5) || (1 < TP)) ||
							((HD < -1) || (5 < HD)) ||
							((IM < -1) || (5 < IM)) ||
							((HF < 0) || (6 < HF)));

						break;
					case "センターライン":
						error = (((HB < -11) || (1 < HB)) ||
							((TP < -11) || (1 < TP)) ||
							((HD < -12) || (0 < HD)) ||
							((IM < -16) || (-4 < IM)) ||
							((HF < -12) || (6 < HF)));
						break;
					case "センターポジション":
						error = (((HB < -5) || (1 < HB)) ||
							((TP < -5) || (1 < TP)) ||
							((HD < -2) || (4 < HD)) ||
							((IM < -1) || (7 < IM)) ||
							((HF < -1) || (12 < HF)));
						break;
					case "ライトライン": {
						const UNDER = AD - 5;
						const OVER = AD + 1;
						error = (((HB < UNDER) || (OVER < HB)) ||
							((TP < UNDER) || (OVER < TP)))
					}
						break;
					case "レフトライン": {
						const UNDER = AD - 7;
						const OVER = AD - 1;
						error = (((HD < UNDER) || (OVER < HD)) ||
							((IM < UNDER) || (OVER < IM)) ||
							((HF < UNDER) || (OVER < HF)))
					}
						break;
					case "右膝の角度": {

					}
						break;
					case "左膝の角度": {

					}
						break;
					default:
						break;
				}
				break;
			default:
		}
		return error;
	}

	/**
	 * @returns none
	 */
	private Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

	/**
	 * @returns none
	 */
	private header(keys: any): string[] {
		const result = [""];
		keys.forEach((key: any): void => {
			result.push(this.phaseToName(key));
		})
		return result;
	}

	/**
	 * @returns none
	 */
	private pointToName(point: string): string {
		let result: string = "";
		switch (point) {
			case "前傾角度":
				result = "前傾ライン";
				break;
			case "首元の動き":
				result = "ネックポジション";
				break;
			case "背骨の傾き":
				result = "センターライン";
				break;
			case "重心の動き_正面":
				result = "センターポジション";
				break;
			case "右腰の動き":
				result = "ライトライン";
				break;
			case "左腰の動き":
				result = "レフトライン";
				break;
			case "右膝の角度":
				result = "右膝の角度";
				break;
			case "左膝の角度":
				result = "左膝の角度";
				break;
			default:
				break;
		}
		return result;
	}

	/**
	 * @returns none
	 */
	private phaseToName(phase: string): string {
		let result: string = "";
		switch (phase) {
			case "address":
				result = "AD";
				break;
			case "backswing":
				result = "HB";
				break;
			case "top":
				result = "TP";
				break;
			case "halfdown":
				result = "HD";
				break;
			case "impact":
				result = "IM";
				break;
			case "follow":
				result = "HF";
				break;
			case "finish":
				result = "FN";
				break;
			default:
				break;
		}
		return result;
	}

	/**
	 * @returns none
	 */
	private draw(shot: any): void {

		this.Progress(true);
		try {
			if (shot) {
				const sm: any = shot.sm;
				const platform: any = shot.platform;
				let judgment: boolean = false;
				if (sm) {
					const table: any[][] = [];
					Object.keys(sm).forEach((point_key, index) => {
						const point = sm[point_key];
						if (index === 0) {
							table.push(this.header(Object.keys(point)));
						}
						const name = this.pointToName(point_key);
						if (name) {
							const line: string[] = [name];
							Object.keys(point).forEach((phase_key) => {
								const phase = point[phase_key];
								const metrics = Math.floor(phase.metrics).toString();
								line.push(metrics);
							});
							judgment = judgment || this.isError(platform.description.club, line);
						}
					})
					this.judgment = judgment;
				}
			} else {
				// Todo: error code messege
			}
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		if (changes) {
			this.hasData = this.shot;
			Object.keys(changes).forEach((propName) => {
				switch (propName) {
					case "visible":
					case "shot":
						if (this.visible) {
							this.draw(this.shot);
						}
						break;
					default:
				}
			});
		} else {
			// Todo: error code messege
		}
	}

}
